module.exports = __webpack_public_path__ + "static/love-does.1937a5c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logos/love-does.png
// module id = 1293
// module chunks = 168707334958949